import { render, staticRenderFns } from "./trainingQusetionAnswer.vue?vue&type=template&id=27fb0518"
import script from "./trainingQusetionAnswer.vue?vue&type=script&lang=js"
export * from "./trainingQusetionAnswer.vue?vue&type=script&lang=js"
import style0 from "./trainingQusetionAnswer.vue?vue&type=style&index=0&id=27fb0518&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports